import {
  Chip,
  Col,
  DisplayData,
  FormattedCurrency,
  FormattedDate,
  FormattedDecimal,
  Row,
  SectionTitle,
  formatUtils
} from '@elotech/components';
import PropTypes from 'prop-types';
import React from 'react';

import { porExtenso } from './../../utils/NumeroExtenso';
import { useCamposLocalizacao } from '../../hooks/useCamposLocalizacao';
import { getCamposLocalizacaoRural } from '../../utils/InscricaoCadastralUtils';
import DisplayIdentificacaoRequisicao from './identificacao/DisplayIdentificacao';

const RenderDadosTransferencia = ({
  dadosTransferencia,
  valorRecursoProprio,
  utilizaFluxoAutonomiaCidadao
}) => {
  const isResumoPage = window.location.pathname.includes('/resumo');
  const financiadoOrAnuencia =
    dadosTransferencia.tipoItbi.financiado ||
    dadosTransferencia.tipoItbi.anuencia;
  const totalAvaliado =
    dadosTransferencia.valorTransacaoAvaliacao +
    dadosTransferencia.valorFinanciadoAvaliacao;
  const totalItbi =
    dadosTransferencia.valorTransacaoItbi +
    dadosTransferencia.valorFinanciadoItbi;

  const isDeferido = () => {
    switch (dadosTransferencia.situacaoItbi?.name) {
      case 'RASCUNHO':
      case 'AGUARDANDO_ANALISE':
      case 'ANALISANDO':
      case 'INDEFERIDO':
        return false;
      default:
        return true;
    }
  };

  return (
    <div>
      <SectionTitle>Dados Transferência</SectionTitle>
      <div className="display-data border small mt-xs">
        <Row>
          {dadosTransferencia.numero && (
            <div className={'col-sm-10'}>
              <DisplayData title="Número do Pedido">
                {dadosTransferencia.numero}
              </DisplayData>
            </div>
          )}
          {dadosTransferencia.situacaoItbi && (
            <div className={'col-sm-2'}>
              <DisplayData title="Situação">
                {<Chip value={dadosTransferencia.situacaoItbi.descricao} />}
              </DisplayData>
            </div>
          )}
        </Row>
        <Row>
          {dadosTransferencia.data && (
            <div className={'col-sm-4'}>
              <DisplayData title="Data">
                <FormattedDate
                  value={dadosTransferencia.data}
                  timeZone={'UTC'}
                />
              </DisplayData>
            </div>
          )}
          <div className={'col-sm-8'}>
            <DisplayData title="Requerente" data-cy="requerente">
              {dadosTransferencia.requerenteNome ||
                (dadosTransferencia.requerente &&
                  dadosTransferencia.requerente.nome)}
            </DisplayData>
          </div>
        </Row>
        <Row>
          <div className={'col-sm-5'}>
            <DisplayData title="Situação">
              {dadosTransferencia.situacaoItbi.descricao}
            </DisplayData>
          </div>
          <div className={'col-sm-7'}>
            <DisplayData title="Tipo de ITBI" data-cy="tipoITBI">
              {dadosTransferencia.tipoItbi.descricao ||
                dadosTransferencia.tipoItbi.label}
            </DisplayData>
          </div>
        </Row>
        <Row>
          <div className={'col-sm-6'}>
            <DisplayData
              title={
                dadosTransferencia.tipoItbi.financiado && valorRecursoProprio
                  ? 'Valor Recurso Próprio'
                  : 'Valor Transação'
              }
              data-cy="valorTransacao"
            >
              <FormattedCurrency value={dadosTransferencia.valorTransacao} />
              {` (${porExtenso(dadosTransferencia.valorTransacao)})`}
            </DisplayData>
          </div>
          {(utilizaFluxoAutonomiaCidadao || isDeferido()) && (
            <div className="col-sm-6">
              <DisplayData
                title="Valor avaliado"
                data-cy="valorTransacaoAvaliacao"
              >
                <FormattedCurrency
                  value={dadosTransferencia.valorTransacaoAvaliacao}
                />
                {` (${porExtenso(dadosTransferencia.valorTransacaoAvaliacao)})`}
              </DisplayData>
            </div>
          )}
          {(utilizaFluxoAutonomiaCidadao || isDeferido()) && (
            <div className={'col-sm-6'}>
              <DisplayData
                title="Valor Transação ITBI"
                data-cy="valorTransacaoItbi"
              >
                <FormattedCurrency
                  value={dadosTransferencia.valorTransacaoItbi}
                />
                {` (${porExtenso(dadosTransferencia.valorTransacaoItbi)})`}
              </DisplayData>
            </div>
          )}
          {!isResumoPage &&
            utilizaFluxoAutonomiaCidadao &&
            dadosTransferencia.retificadora && (
              <div className={'col-sm-6'}>
                <DisplayData
                  title="Valor Guia Retificação"
                  data-cy="valorGuiaRetificacao"
                >
                  <FormattedCurrency
                    value={
                      dadosTransferencia.valorTransacaoItbi -
                        dadosTransferencia.valorOriginal || 0
                    }
                  />
                  {` (${porExtenso(
                    dadosTransferencia.valorTransacaoItbi -
                      dadosTransferencia.valorOriginal
                  )})`}
                </DisplayData>
              </div>
            )}
        </Row>
        <Row>
          {!!dadosTransferencia.valorFinanciado && (
            <div className={'col-sm-6'}>
              <DisplayData
                title={
                  dadosTransferencia.tipoItbi.financiado
                    ? 'Valor Financiado'
                    : 'Valor Anuência'
                }
              >
                <FormattedCurrency value={dadosTransferencia.valorFinanciado} />
                {` (${porExtenso(dadosTransferencia.valorFinanciado)})`}
              </DisplayData>
            </div>
          )}
          {financiadoOrAnuencia && (
            <>
              {dadosTransferencia.aliquotaFinanciado > 0 && (
                <div className="col-sm-6">
                  <DisplayData title="Alíquota">
                    <FormattedDecimal
                      value={dadosTransferencia.aliquotaFinanciado / 100}
                      maximumSignificantDigits={3}
                      type="percent"
                    />
                  </DisplayData>
                </div>
              )}

              {dadosTransferencia.valorFinanciadoItbi > 0 && (
                <div className="col-sm-6">
                  <DisplayData
                    title={
                      dadosTransferencia.tipoItbi?.financiado
                        ? 'Valor ITBI Financiado'
                        : 'Valor ITBI Anuência'
                    }
                  >
                    <FormattedCurrency
                      value={dadosTransferencia.valorFinanciadoItbi}
                    />
                  </DisplayData>
                </div>
              )}
            </>
          )}
        </Row>
        {financiadoOrAnuencia && (
          <>
            <Row>
              {totalAvaliado > 0 && (
                <div className={'col-sm-12'}>
                  <DisplayData title="Total Avaliado">
                    <FormattedCurrency value={totalAvaliado} />
                  </DisplayData>
                </div>
              )}

              {totalItbi > 0 && (
                <div className={'col-sm-6'}>
                  <DisplayData title="Total ITBI">
                    <FormattedCurrency value={totalItbi} />
                  </DisplayData>
                </div>
              )}
            </Row>
          </>
        )}
        <Row>
          <div className={'col-sm-12'}>
            <DisplayData title="Observação">
              {dadosTransferencia.observacaoCidadao}
            </DisplayData>
          </div>
        </Row>
        {dadosTransferencia.motivoIndeferimento && (
          <Row>
            <div className={'col-sm-12'}>
              <DisplayData title="Motivo do indeferimento">
                {dadosTransferencia.motivoIndeferimento}
              </DisplayData>
            </div>
          </Row>
        )}
        {dadosTransferencia.motivoCancelamento && (
          <Row>
            <div className={'col-sm-12'}>
              <DisplayData title="Motivo do Cancelamento">
                {dadosTransferencia.motivoCancelamento}
              </DisplayData>
            </div>
          </Row>
        )}
      </div>
    </div>
  );
};

/** Campos de localização do cadastro urbano ou rural, conforme a configuração do município. */
const CamposLocalizacao = ({ cadastro, camposLocalizacao, rural = false }) => {
  const campos = useCamposLocalizacao(camposLocalizacao);

  return (rural ? getCamposLocalizacaoRural(campos) : campos).map(
    ({ campo, label, campoCadastro }) => (
      <div className={'col-sm-2'} key={campo}>
        <DisplayData title={label}>{cadastro[campoCadastro]}</DisplayData>
      </div>
    )
  );
};

const DadosCadastroImobiliario = ({
  cadastroImobiliario,
  camposLocalizacao
}) => (
  <div>
    <SectionTitle>Dados do Imóvel</SectionTitle>
    <div className="display-data border small mt-xs">
      <div className="row">
        <div className={'col-sm-3'}>
          <DisplayData
            title="Cadastro Imobiliário"
            data-cy="cadastroImobiliario"
          >
            {cadastroImobiliario.cadastro}
          </DisplayData>
        </div>
        <div className={'col-sm-4'}>
          <DisplayData title="Inscrição Cadastral">
            {cadastroImobiliario.inscricaoCadastral}
          </DisplayData>
        </div>
      </div>
      <div className="row">
        <CamposLocalizacao
          cadastro={cadastroImobiliario}
          camposLocalizacao={camposLocalizacao}
        />
      </div>
      <div className="row">
        <div className={'col-sm-12'}>
          <DisplayData title="Complemento do Lote">
            {cadastroImobiliario.complementoLote || ''}
          </DisplayData>
        </div>
      </div>
      <div className="row">
        <div className={'col-sm-3'}>
          <DisplayData
            title={'Área Terreno'}
          >{`${cadastroImobiliario.areaTerreno} m²`}</DisplayData>
        </div>
        <div className={'col-sm-3'}>
          <DisplayData
            title={'Área Construida'}
          >{`${cadastroImobiliario.areaConstruida} m²`}</DisplayData>
        </div>
      </div>
      <div className="row">
        <div className={'col-sm-2'}>
          <DisplayData title={'CEP'}>
            {formatUtils.formatCep(cadastroImobiliario.cep)}
          </DisplayData>
        </div>
        <div className={'col-sm-5'}>
          <DisplayData title={'Endereço'}>
            {cadastroImobiliario.endereco}
          </DisplayData>
        </div>
        <div className={'col-sm-2'}>
          <DisplayData title={'Nº'}>{cadastroImobiliario.numero}</DisplayData>
        </div>
        <div className={'col-sm-3'}>
          <DisplayData title={'Complemento'}>
            {cadastroImobiliario.complemento || ''}
          </DisplayData>
        </div>
      </div>
      <div className="row">
        <div className={'col-sm-5'}>
          <DisplayData title={'Bairro'}>
            {cadastroImobiliario.bairro}
          </DisplayData>
        </div>
        <div className={'col-sm-5'}>
          <DisplayData title={'Cidade'}>
            {cadastroImobiliario.cidade}
          </DisplayData>
        </div>
        <div className={'col-sm-2'}>
          <DisplayData title={'Estado'}>
            {cadastroImobiliario.estado}
          </DisplayData>
        </div>
      </div>
      <div className="row">
        <div className={'col-sm-12'}>
          <DisplayData title={'Condomínio'}>
            {cadastroImobiliario.condominio
              ? `${cadastroImobiliario.condominio} -
            ${cadastroImobiliario.descricaoCondominio}`
              : ''}
          </DisplayData>
        </div>
      </div>
    </div>
  </div>
);

const DadosEnglobados = ({ englobados }) => {
  if (!englobados || englobados.length === 0) {
    return null;
  }
  return (
    <div>
      <SectionTitle>Cadastros Englobados</SectionTitle>
      <div className="display-data border small mt-xs">
        {englobados.map(englobado => (
          <div
            className="row"
            key={englobado.cadastro || englobado.cadastroGeral}
          >
            <div className={'col-sm-3'}>
              <DisplayData title="Cadastro">
                {englobado.cadastro || englobado.cadastroGeral}
              </DisplayData>
            </div>
            <div className={'col-sm-4'}>
              <DisplayData title="Inscrição Cadastral">
                {englobado.inscricaoCadastral}
              </DisplayData>
            </div>
            <div className={'col-sm-3'}>
              <DisplayData title="Endereço">{englobado.endereco}</DisplayData>
            </div>
            <div className={'col-sm-2'}>
              <DisplayData title="Cadastro Pai">
                {englobado.pai ? 'Sim' : 'Não'}
              </DisplayData>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const DadosCadastroRural = ({ cadastro, camposLocalizacao }) => (
  <div>
    <SectionTitle>Dados do Cadastro Rural</SectionTitle>
    <div className="display-data border small mt-xs">
      <Row>
        <Col sm={3}>
          <DisplayData title="Cadastro Rural" data-cy="cadastroRural">
            {cadastro.cadastro}
          </DisplayData>
        </Col>
        <Col sm={4}>
          <DisplayData title="Nome da Propriedade">{cadastro.nome}</DisplayData>
        </Col>
        <Col sm={5}>
          <DisplayData title="Endereço">
            {cadastro.enderecoDescrito}
          </DisplayData>
        </Col>
      </Row>
      <Row>
        <Col sm={4}>
          <DisplayData title="Logradouro">{cadastro.logradouro}</DisplayData>
        </Col>
        <Col sm={2}>
          <DisplayData title="Bairro">{cadastro.bairro}</DisplayData>
        </Col>
        <Col sm={2}>
          <DisplayData title="Complemento">{cadastro.complemento}</DisplayData>
        </Col>
        <CamposLocalizacao
          rural
          cadastro={cadastro}
          camposLocalizacao={camposLocalizacao}
        />
      </Row>
      <Row>
        <Col sm={2}>
          <DisplayData title={'NIRF'}>{cadastro.numeroReceita}</DisplayData>
        </Col>
        <Col sm={2}>
          <DisplayData title={'Número no Incra'}>
            {cadastro.numeroIncra}
          </DisplayData>
        </Col>
        <Col sm={2}>
          <DisplayData title={'Qtd. Alqueires'}>
            {cadastro.alqueires}
          </DisplayData>
        </Col>
        <Col sm={2}>
          <DisplayData title={'Qtd. Hectares'}>{cadastro.hectares}</DisplayData>
        </Col>
        <Col sm={2}>
          <DisplayData title={'Área Total'}>{cadastro.areaTotal}</DisplayData>
        </Col>
      </Row>
    </div>
  </div>
);

const RenderListPessoa = ({
  title,
  list,
  onViewPessoa,
  isServidor,
  proprietario
}) => (
  <div>
    <SectionTitle>{title}</SectionTitle>
    <div className="display-data border small mt-xs has-btn-actions">
      {list.map(pessoa => (
        <DisplayIdentificacaoRequisicao
          key={pessoa.cpfCnpj}
          data-cy={title}
          vendedor={!!pessoa.percentualVenda}
          proprietario={proprietario}
          pessoa={pessoa}
          onViewPessoa={onViewPessoa}
          isServidor={isServidor}
        />
      ))}
    </div>
  </div>
);

const RenderList = ({
  title,
  list = [],
  onViewPessoa,
  isServidor,
  proprietario
}) => {
  if (list.length > 0) {
    return (
      <RenderListPessoa
        title={title}
        list={list}
        onViewPessoa={onViewPessoa}
        isServidor={isServidor}
        proprietario={proprietario}
      />
    );
  }
  return null;
};

const AliquotaDiferenciadaResumo = ({
  aliquotaDiferenciadasAplicadas = []
}) => {
  if (!aliquotaDiferenciadasAplicadas?.length) {
    return null;
  }

  const groupAliquotas = aliquotas => {
    let aggregator = {};
    for (const aliquota of aliquotas) {
      const key = aliquota.tipoAliquota;
      let values = aggregator[key] ?? [];
      values.push(aliquota);
      aggregator[key] = values;
    }
    return aggregator;
  };

  const renderAliquotaDiferenciadaPorIntervalo = aliquotas => {
    const column = (
      label,
      value,
      size = 2,
      rightAlign = true,
      justifyContent
    ) => (
      <Col sm={size} style={rightAlign ? { textAlign: 'right' } : {}}>
        <b className="dd-title">{label}</b>
        <div className="dd-content">{value}</div>
      </Col>
    );

    return (
      <>
        <Row>
          <SectionTitle>
            {' '}
            Tipo de aplicação da alíquota: INTERVALO{' '}
          </SectionTitle>
        </Row>
        {aliquotas.map(
          ({
            tipoAliquota,
            aliquota,
            valorCalculado,
            baseCalculo,
            valorInicialIntervalo,
            valorFinalIntervalo
          }) => (
            <Row key={`${tipoAliquota}-${valorInicialIntervalo}`}>
              {column(
                'Alíquota para o tributo ',
                String(tipoAliquota).toUpperCase(),
                2,
                false
              )}
              {column(
                'Valor Inicial Intervalo',
                <FormattedCurrency value={valorInicialIntervalo} />
              )}
              {column(
                'Valor Final Intervalo',
                <FormattedCurrency value={valorFinalIntervalo} />
              )}
              {column(
                'Base de calculo',
                <FormattedCurrency value={baseCalculo} />
              )}
              {column(
                'Alíquota',
                <FormattedDecimal
                  value={aliquota / 100}
                  maximumSignificantDigits={3}
                  type="percent"
                />
              )}
              {column(
                'Valor calculado',
                <FormattedCurrency value={valorCalculado} />
              )}
            </Row>
          )
        )}
      </>
    );
  };

  return (
    <div>
      <SectionTitle>Alíquotas Diferenciadas Aplicadas</SectionTitle>
      <div className="display-data border small mt-xs">
        {Object.entries(groupAliquotas(aliquotaDiferenciadasAplicadas)).map(
          ([_, values]) =>
            values.sort((a1, a2) => a1.valorFinal - a2.valorFinal) &&
            renderAliquotaDiferenciadaPorIntervalo(values)
        )}
      </div>
    </div>
  );
};

const ResumoDeclaracao = ({
  compradores,
  vendedores,
  anuentes,
  proprietarios,
  dadosImovel,
  declaracao,
  valorRecursoProprio,
  onViewPessoa,
  isServidor,
  utilizaFluxoAutonomiaCidadao,
  camposLocalizacao
}) => {
  return (
    <React.Fragment>
      <RenderDadosTransferencia
        dadosTransferencia={dadosImovel}
        valorRecursoProprio={valorRecursoProprio}
        utilizaFluxoAutonomiaCidadao={utilizaFluxoAutonomiaCidadao}
      />

      {!isServidor && utilizaFluxoAutonomiaCidadao && (
        <AliquotaDiferenciadaResumo
          aliquotaDiferenciadasAplicadas={
            dadosImovel.aliquotaDiferenciadasAplicadas
          }
        />
      )}

      {dadosImovel.tipoImovel === 'URBANO' ? (
        <DadosCadastroImobiliario
          cadastroImobiliario={dadosImovel.cadastroImobiliario}
          camposLocalizacao={camposLocalizacao}
        />
      ) : (
        <DadosCadastroRural
          cadastro={dadosImovel.cadastroRural}
          camposLocalizacao={camposLocalizacao}
        />
      )}

      {dadosImovel.tipoImovel === 'URBANO' && (
        <DadosEnglobados englobados={dadosImovel.englobados} />
      )}

      <RenderList
        title="Compradores"
        list={compradores}
        onViewPessoa={onViewPessoa}
        isServidor={isServidor}
      />
      <RenderList
        title="Vendedores"
        list={vendedores}
        onViewPessoa={onViewPessoa}
        isServidor={isServidor}
      />
      <RenderList
        title="Anuentes/Cedentes"
        list={anuentes}
        onViewPessoa={onViewPessoa}
        isServidor={isServidor}
      />

      {utilizaFluxoAutonomiaCidadao && !isServidor && (
        <RenderList
          title="Proprietários"
          list={proprietarios || []}
          onViewPessoa={onViewPessoa}
          isServidor={isServidor}
          proprietario={true}
        />
      )}
    </React.Fragment>
  );
};

ResumoDeclaracao.propTypes = {
  compradores: PropTypes.array.isRequired,
  vendedores: PropTypes.array.isRequired,
  anuentes: PropTypes.array.isRequired,
  proprietarios: PropTypes.array,
  dadosImovel: PropTypes.object.isRequired,
  declaracao: PropTypes.object,
  valorRecursoProprio: PropTypes.bool.isRequired,
  onViewPessoa: PropTypes.func.isRequired,
  isServidor: PropTypes.bool.isRequired,
  utilizaFluxoAutonomiaCidadao: PropTypes.bool,
  /** Campos de localização já carregados pela tela; sem eles, o resumo carrega a configuração. */
  camposLocalizacao: PropTypes.array
};

export default ResumoDeclaracao;
